import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTheme } from '@mui/material';

export const Help = () => {
  const theme = useTheme();

  return (
    <HelpOutlineIcon
      fontSize="medium"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
